/*
* Association location form view for authenticated users
*/

import * as _ from 'lodash';
import * as React from 'react';

import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
import * as DetailFormCommon from './common';

export const AssociationDetailsLocation = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsFullWidthTextDebounced = _.merge({}, defaultInputProps, {
        // onChange: (n, v) => { handleFormInputChange(n, v); },
        handleChange: (n, v) => { handleFormInputChange(n, v); },
        className: 'inventory-detail-input-full-width',
        colLabelXs: 4,
        colInputXs: 8,
    });

    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <div>
                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="name"
                        label={appText('association-name')}
                        value={formData.name}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <DetailFormCommon.AssociationDetailFormSectionSpacing />

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.address1"
                        label={appText('address')}
                        value={formData.location.address1}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.address2"
                        label={appText('address2')}
                        value={formData.location.address2}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.city"
                        label={appText('city')}
                        value={formData.location.city}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.stateCode"
                        label={appText('state')}
                        value={formData.location.stateCode}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>

                <div>
                    <KendoWrappers.KendoTextInputDebounced
                        name="location.postalCode"
                        label={appText('zip')}
                        value={formData.location.postalCode}
                        {...inputPropsFullWidthTextDebounced}
                    />
                </div>
            </div>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details-location.tsx